export default __webpack_public_path__ + "static/media/net.21b7135f.png";